import React from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles';
import { List, ListItem, ListSubheader, ListItemIcon, ListItemText, Divider,Snackbar } from '@material-ui/core';
import * as actions from '../../Store/Actions'
import SettingsIcon from '@material-ui/icons/Settings';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { green } from '@material-ui/core/colors';
import CircularProgress from '@material-ui/core/CircularProgress';
import axios from '../../Helpers/Axiosbase'
import MuiAlert from '@material-ui/lab/Alert';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

// import * as actions from '../../Store/Actions'

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    radius: '5px',
  },
  header: {
    background: 'linear-gradient(45deg,#3883fa 90%,#3883fa 10%)',
    color: 'white',
    fontSize: 18
  },
  loader: {
    position: 'absolute',
    left: '40%',
    top: '250px',
  },
  listitem: {
    paddingTop: '3px',
    paddingBottom: '3px',
    paddingLeft: '8px',
    // border: '1px solid rgba(0,0,0,.125)',
    // backgroundColor:'#f8f9fa!important',
  },
  listitemicon: {
    size: 3,
    minWidth: '35px'
  },
  listItemText: {
    fontSize: '15px',
    fontFamily: 'Open Sans, sans-serif',
  }


}));

export default function Componentselector() {
  const classes = useStyles();
  const appcomponent = useSelector((state) => state.appcomponent)
  const [selectedIndex, setSelectedIndex] = React.useState(appcomponent.selectedComponent!==null && appcomponent.selectedComponent!==undefined?appcomponent.selectedComponent.displaySequence-1:0);

  const reduxAuth = useSelector((state) => state.auth)
  const dispatch = useDispatch();
  const urladd = window.location.href;
  let showLoader = true;

  const [errorMessage,setErrorMessage]=React.useState({
    open:false,
    errmsg:null,
  });

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
  };


  const handleListItemClick = (data, index) => {
    setSelectedIndex(index);
    dispatch(actions.selectedComponent(data))
    dispatch(actions.configuration());
  };
  let component = null;

  if (appcomponent.allComponent != null && appcomponent.selectedApp != null) {
    let index=0
    let fdata=[];
    let filtercomponent = appcomponent.allComponent.filter((data) => {
       
       return(data.appids.value.indexOf(appcomponent.selectedApp._id) > -1)
        
    });

    filtercomponent=filtercomponent.map((data,index)=>{
      data.displaySequence=index+1
      return data
    })

    // console.log("filtercomponent",filtercomponent)

    if (appcomponent.selectedComponent == null && filtercomponent.length > 0) {
      dispatch(actions.selectedComponent(filtercomponent[0]))
      dispatch(actions.configuration());
      setSelectedIndex(0);
      dispatch(actions.attributelist());
    }
    component = filtercomponent.map((data, index) => {
      return (<ListItem button key={index} onClick={() => handleListItemClick(data, index)} selected={selectedIndex === index} disabled={urladd.includes("ManageConfig") || urladd.includes("AddConfiguration") || (appcomponent.selectedEnvironment != null && appcomponent.selectedEnvironment.isSync.toString() === "0")} className={classes.listitem}>
        <ListItemIcon className={classes.listitemicon}>
          {selectedIndex === index ? <CheckCircleIcon style={{ color: green[900], fontSize: '1.3rem' }}></CheckCircleIcon> : <SettingsIcon style={{ color: 'black', fontSize: '1.3rem' }}></SettingsIcon>}
        </ListItemIcon>
        <ListItemText primary={data.displayName} classes={{ primary: classes.listItemText }} />
      </ListItem>
      );
    });
    showLoader = false;
  }

  return (
    <div className={classes.root}>
      <Snackbar
                open={appcomponent.configFail!=null} autoHideDuration={3000} anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                onClose={handleClose}>
                    <Alert 
                    severity="error"
                    color="error"
                    variant="filled">
                      NetWork Error:Please Check Your Internet Connection
                    {/* {errorMessage.errmsg!=null?errorMessage.errmsg:" NetWork Error:Please Check Your Internet Connection"} */}
                    </Alert>
            </Snackbar>
      <List
        component="nav"
        aria-labelledby="nested-list-subheader"
        subheader={
          <ListSubheader className={classes.header} component="div" id="nested-list-subheader">
            Components
          </ListSubheader>}>
        <Divider></Divider>
        <Divider></Divider>
        <Divider></Divider>
        {showLoader === true ? <CircularProgress className={classes.loader} /> : null}
        {component}
        <Divider></Divider>
      </List>
    </div>
  );
}

